//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "#webapp/src/__schema__";
// libraries
import React, { useRef } from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// web-settings-team-settings-renderer imports
import { query } from "./WebSettingsTeamSettingsRelay.gql";
// components
import { WebSettingsContainer } from "#webapp/src/components/web-settings/web-settings-container";
import { Loader } from "@clockwise/web-commons/src/components/loader";
import { PrimaryTeamSelect } from "./PrimaryTeamSelect";
import { TeamAvailabilityCalendar } from "./TeamAvailabilityCalendar";
import { TeamDelete } from "./TeamDelete";
import { TeamMembers } from "./TeamMembers";
import { TeamNoMeetingDay } from "./TeamNoMeetingDay";

// util
import { PageEvents } from "#webapp/src/util/analytics.util";
import { handleReadyStateError } from "#webapp/src/util/relay.util";
import { useTrackPageview } from "@clockwise/web-commons/src/util/analytics.util";
// state
import { getCurrentEnvironment } from "#webapp/src/state/relay-environment";
// material-ui

import { Divider } from "@material-ui/core";
import { TeamName } from "../../team-settings/TeamName";

export interface Props {
  orgRelayId: string;
  teamId?: string;
}

export const WebSettingsTeamSettingsRelay = ({ teamId, orgRelayId }: Props) => {
  const shouldForce = useRef(true);
  useTrackPageview(PageEvents.WEB_SETTINGS_TEAM, { teamId });
  const environment = getCurrentEnvironment();

  return (
    <QueryRenderer
      environment={environment}
      query={query}
      variables={{
        orgRelayId: orgRelayId,
        teamId: teamId,
      }}
      cacheConfig={{ force: shouldForce.current }}
      render={(readyState: ReadyState) => {
        // check for error or show a loader for first load
        if (readyState.error) {
          handleReadyStateError(readyState.error, "WebSettingsTeamSettingsRenderer");
          return null;
        }

        const org: ISchema.IOrg = readyState.props && readyState.props.org;

        if (!org) {
          return <Loader />;
        }

        shouldForce.current = false;

        const team =
          (org.userTeams.__typename === "TeamList" &&
            org.userTeams.list.find((t) => t.teamId === teamId)) ||
          null;

        return (
          <WebSettingsContainer>
            <div className="cw-flex cw-items-center cw-justify-between cw-mb-11">
              <TeamName id={team?.teamId} />
              <PrimaryTeamSelect pageTeamId={team?.teamId} />
            </div>
            {team ? (
              <>
                <TeamMembers org={org} team={team} />
                <Divider className="cw-mt-16 cw-mb-16" />
                <TeamAvailabilityCalendar teamId={team.teamId} />
                <Divider className="cw-mt-16 cw-mb-16" />
                <TeamNoMeetingDay teamId={team.teamId} />
                <Divider className="cw-mt-16 cw-mb-16" />
                <TeamDelete org={org} team={team} />
              </>
            ) : (
              <div>Failed to render team</div>
            )}
          </WebSettingsContainer>
        );
      }}
    />
  );
};
